import { AsyncLoadingSection, DisplayBlock, PageCard, PageCardSection, buildEndpoint, defaultDataTransform, useDataFetcher } from '@techsharegov/react-ui';
import { useCommitteeState } from './CommitteeProvider';
import { AgendaEndpoints } from 'Models/Routes';
import { Row } from 'reactstrap';

export class CommitteeMembersTabModel {
  countyName?: string;
  name?: string;
  committeeMembers?: CommitteeMemberModel[];
}

export class CommitteeMemberModel {
  id?: string;
  name?: string;
  position?: string;
}

export const CommitteeMembers: React.FC = () => {
  const { committeeId } = useCommitteeState();

  const [data, loadingStatus] = useDataFetcher<CommitteeMembersTabModel>(
    buildEndpoint(AgendaEndpoints.committees.controllerActionString("members"), committeeId),
    new CommitteeMembersTabModel(),
    defaultDataTransform,
    CommitteeMembersTabModel
  );

  return (
    <AsyncLoadingSection loadingStatus={loadingStatus}>
      <PageCard>
        <PageCardSection title={data.countyName + " County " + data.name + " members:"}>
          <Row className='row-no-left-margin'>
            {data?.committeeMembers?.map((committeeMember, index) => 
              <DisplayBlock 
                key={index}
                title={committeeMember.name as string}
                value={committeeMember?.position}
                width="50%"
              />
            )}
          </Row>
        </PageCardSection>
      </PageCard>
    </AsyncLoadingSection>
  );
};
